<template>
    <breadCrumbs title="Basic Card" main="Bonus UI" title1="Basic Card" />

    <div class="container-fluid">
        <div class="row">
            <basic6Page />
        </div>
    </div>
</template>
<script>
import basic6Page from './basic6Page.vue';
export default {
    components: {
        basic6Page,
    }
}
</script>